export const ScreenLineType = {
    RegularText: 0,
    BoldText: 1,
    DetailText: 2,
    EnrollmentLink: 3,
    ApplicationLink: 4,
    DocumentLink: 5,
    GreenText: 6,
    RedText: 7,
    OrangeText: 8
}

export const ResultType = {
    Success: 0,
    Enrolled: 1,
    Denied: 2,
    Received: 3,
    Error: 4,
    Cancelled: 5
}

export const CallStatus = {
    NotStarted: 0,
    Started: 1,
    Completed: 2,
    Error: 3,
    Cancelled: 4
}

export const ButtonType = {
    NoButton: 0,
    Continue: 1,
    TryAgain: 2,
    //no three...
    TryAgainLater: 4,
    Error: 6,
}

export const ServiceCategory = {
    Copay: 1,
    FreeDrug: 2,
    BenefitVerification: 20
}

//copied directly from AP1, hence the cap propnames
export const States = [
    { Name: 'Alabama', Value: 'AL', IsDefault: false },
    { Name: 'Alaska', Value: 'AK', IsDefault: false },
    { Name: 'Arizona', Value: 'AZ', IsDefault: false },
    { Name: 'Arkansas', Value: 'AR', IsDefault: false },
    { Name: 'California', Value: 'CA', IsDefault: false },
    { Name: 'Colorado', Value: 'CO', IsDefault: false },
    { Name: 'Connecticut', Value: 'CT', IsDefault: false },
    { Name: 'Delaware', Value: 'DE', IsDefault: false },
    { Name: 'Florida', Value: 'FL', IsDefault: false },
    { Name: 'Georgia', Value: 'GA', IsDefault: false },
    { Name: 'Hawaii', Value: 'HI', IsDefault: false },
    { Name: 'Idaho', Value: 'ID', IsDefault: false },
    { Name: 'Illinois', Value: 'IL', IsDefault: false },
    { Name: 'Indiana', Value: 'IN', IsDefault: false },
    { Name: 'Iowa', Value: 'IA', IsDefault: false },
    { Name: 'Kansas', Value: 'KS', IsDefault: false },
    { Name: 'Kentucky', Value: 'KY', IsDefault: false },
    { Name: 'Louisiana', Value: 'LA', IsDefault: false },
    { Name: 'Maine', Value: 'ME', IsDefault: false },
    { Name: 'Maryland', Value: 'MD', IsDefault: false },
    { Name: 'Massachusetts', Value: 'MA', IsDefault: false },
    { Name: 'Michigan', Value: 'MI', IsDefault: false },
    { Name: 'Minnesota', Value: 'MN', IsDefault: false },
    { Name: 'Mississippi', Value: 'MS', IsDefault: false },
    { Name: 'Missouri', Value: 'MO', IsDefault: false },
    { Name: 'Montana', Value: 'MT', IsDefault: false },
    { Name: 'Nebraska', Value: 'NE', IsDefault: false },
    { Name: 'Nevada', Value: 'NV', IsDefault: false },
    { Name: 'New Hampshire', Value: 'NH', IsDefault: false },
    { Name: 'New Jersey', Value: 'NJ', IsDefault: false },
    { Name: 'New Mexico', Value: 'NM', IsDefault: false },
    { Name: 'New York', Value: 'NY', IsDefault: false },
    { Name: 'North Carolina', Value: 'NC', IsDefault: false },
    { Name: 'North Dakota', Value: 'ND', IsDefault: false },
    { Name: 'Ohio', Value: 'OH', IsDefault: false },
    { Name: 'Oklahoma', Value: 'OK', IsDefault: false },
    { Name: 'Oregon', Value: 'OR', IsDefault: false },
    { Name: 'Pennsylvania', Value: 'PA', IsDefault: false },
    { Name: 'Rhode Island', Value: 'RI', IsDefault: false },
    { Name: 'South Carolina', Value: 'SC', IsDefault: false },
    { Name: 'South Dakota', Value: 'SD', IsDefault: false },
    { Name: 'Tennessee', Value: 'TN', IsDefault: false },
    { Name: 'Texas', Value: 'TX', IsDefault: false },
    { Name: 'Utah', Value: 'UT', IsDefault: false },
    { Name: 'Vermont', Value: 'VT', IsDefault: false },
    { Name: 'Virginia', Value: 'VA', IsDefault: false },
    { Name: 'Washington', Value: 'WA', IsDefault: false },
    { Name: 'West Virginia', Value: 'WV', IsDefault: false },
    { Name: 'Wisconsin', Value: 'WI', IsDefault: false },
    { Name: 'Wyoming', Value: 'WY', IsDefault: false },
    { Name: '-- US Territories --', IsDefault: false },
    { Name: 'American Samoa', Value: 'AS', IsDefault: false },
    { Name: 'District of Columbia', Value: 'DC', IsDefault: false },
    { Name: 'Federated States of Micronesia', Value: 'FM', IsDefault: false },
    { Name: 'Guam', Value: 'GU', IsDefault: false },
    { Name: 'Marshall Islands', Value: 'MH', IsDefault: false },
    { Name: 'Northern Mariana Islands', Value: 'MP', IsDefault: false },
    { Name: 'Palau', Value: 'PW', IsDefault: false },
    { Name: 'Puerto Rico', Value: 'PR', IsDefault: false },
    { Name: 'Virgin Islands', Value: 'VI', IsDefault: false },
 ];
